/* ==========================================================================
   The WHYTE Ritual — member lounge, vanilla JavaScript (behaviour only)
   All copy lives in account.html. This file never creates text content.
   ========================================================================== */
(function () {
  "use strict";

  /* Scroll reveal --------------------------------------------------------- */
  function initReveal() {
    var nodes = document.querySelectorAll("[data-reveal]");
    if (!nodes.length) return;

    if (typeof IntersectionObserver === "undefined") {
      Array.prototype.forEach.call(nodes, function (node) {
        node.classList.add("is-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.1 },
    );

    Array.prototype.forEach.call(nodes, function (node) {
      observer.observe(node);
    });
  }

  /* Animated progress line ------------------------------------------------ */
  function initProgress() {
    var fill = document.querySelector("[data-progress]");
    if (!fill) return;

    var run = function () {
      fill.classList.add("is-filled");
    };

    if (typeof IntersectionObserver === "undefined") {
      run();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          window.setTimeout(run, 250);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.35 },
    );
    observer.observe(fill);
  }

  /* FAQ accordion — open state declared in the HTML ("is-open") ----------- */
  function setOpen(item, panel, button, open) {
    item.classList.toggle("is-open", open);
    button.setAttribute("aria-expanded", open ? "true" : "false");
    panel.style.maxHeight = open ? panel.scrollHeight + "px" : "0px";
  }

  function initFaq() {
    var container = document.querySelector("[data-faq]");
    if (!container) return;

    var entries = [];
    var items = container.querySelectorAll(".wa-faq__item");

    Array.prototype.forEach.call(items, function (item) {
      var button = item.querySelector(".wa-faq__question");
      var panel = item.querySelector(".wa-faq__answer");
      if (!button || !panel) return;

      var entry = { item: item, button: button, panel: panel };
      entries.push(entry);
      setOpen(item, panel, button, item.classList.contains("is-open"));

      button.addEventListener("click", function () {
        var willOpen = !item.classList.contains("is-open");
        entries.forEach(function (other) {
          setOpen(other.item, other.panel, other.button, false);
        });
        if (willOpen) setOpen(item, panel, button, true);
      });
    });

    window.addEventListener("resize", function () {
      entries.forEach(function (entry) {
        if (entry.item.classList.contains("is-open")) {
          entry.panel.style.maxHeight = entry.panel.scrollHeight + "px";
        }
      });
    });
  }

  /* Referral link — copy + share ------------------------------------------ */
  function initReferral() {
    var wrap = document.querySelector("[data-referral]");
    if (!wrap) return;

    var input = wrap.querySelector("[data-referral-input]");
    var copyBtn = wrap.querySelector("[data-copy]");
    var shareBtn = wrap.querySelector("[data-share]");
    if (!input) return;

    var timer = null;

    function flagCopied() {
      wrap.classList.add("is-copied");
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        wrap.classList.remove("is-copied");
      }, 2600);
    }

    function legacyCopy() {
      input.removeAttribute("readonly");
      input.select();
      input.setSelectionRange(0, input.value.length);
      try {
        document.execCommand("copy");
      } catch (err) {
        /* clipboard unavailable */
      }
      input.setAttribute("readonly", "readonly");
      window.getSelection && window.getSelection().removeAllRanges();
    }

    function copyLink() {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(input.value).then(flagCopied, function () {
          legacyCopy();
          flagCopied();
        });
      } else {
        legacyCopy();
        flagCopied();
      }
    }

    if (copyBtn) copyBtn.addEventListener("click", copyLink);

    if (shareBtn) {
      shareBtn.addEventListener("click", function () {
        if (navigator.share) {
          navigator
            .share({ title: document.title, url: input.value })
            .catch(function () {});
        } else {
          copyLink();
        }
      });
    }
  }

  /* Button press feedback + smooth in-page scrolling ---------------------- */
  function initButtons() {
    var buttons = document.querySelectorAll(".wa-btn");
    Array.prototype.forEach.call(buttons, function (button) {
      button.addEventListener("pointerdown", function () {
        button.classList.add("is-pressed");
      });
      ["pointerup", "pointerleave", "pointercancel"].forEach(function (evt) {
        button.addEventListener(evt, function () {
          button.classList.remove("is-pressed");
        });
      });

      button.addEventListener("click", function (event) {
        var href = button.getAttribute("href") || "";
        if (href.charAt(0) !== "#" || href.length < 2) return;
        var target = document.querySelector(href);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  function init() {
    initReveal();
    initProgress();
    initFaq();
    initReferral();
    initButtons();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* Tabs ------------------------------------------------------------------- */
(function initTabs() {
  var tabs = Array.prototype.slice.call(document.querySelectorAll('[data-tab]'));
  var panels = Array.prototype.slice.call(document.querySelectorAll('[data-tab-panel]'));
  if (!tabs.length || !panels.length) return;

  function activate(name, scroll) {
    tabs.forEach(function (tab) {
      var on = tab.getAttribute('data-tab') === name;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panels.forEach(function (panel) {
      var on = panel.getAttribute('data-tab-panel') === name;
      panel.hidden = !on;
      if (on) {
        panel.querySelectorAll('[data-reveal]').forEach(function (el) {
          el.classList.add('is-visible');
        });
      }
    });
    if (scroll) {
      var nav = document.querySelector('.wa-tabs');
      if (nav) window.scrollTo({ top: nav.offsetTop, behavior: 'smooth' });
    }
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      activate(tab.getAttribute('data-tab'), true);
    });
  });

  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    var target = link.getAttribute('href').slice(1);
    if (!tabs.some(function (t) { return t.getAttribute('data-tab') === target; })) return;
    link.addEventListener('click', function (event) {
      event.preventDefault();
      activate(target, true);
    });
  });

  activate('journey', false);
})();
